import React from 'react'
import '../../../assets/scss/components/Shared/InformationBanner/information-banner.css'

const InformationBanner = ({children}) => {
    return (
    <div className='informationBanner'>
        {children}
    </div>)
}

export default InformationBanner